import { AdminService } from '../../../../admin/services/admin.service';
import { LoanOperationService } from '../../../../credit/services/loan-operations.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ApprovalService } from '../../../../setup/services/approval.service';
import { LoanService } from '../../../../credit/services/loan.service';
import { GeneralSetupService } from '../../../../setup/services/general-setup.service';
import swal from 'sweetalert2';
import { GlobalConfig, ApprovalStatus, ApprovalStatusEnum, LoanSystemTypeEnum, JobSource } from '../../../../shared/constant/app.constant';
import { AuthorizationService } from '../../../../admin/services';
import { LoanApplicationService } from 'app/credit/services/loan-application.service';
import { ReportService } from 'app/reports/service/report.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LMSOperationEnum } from 'app/shared/constant/app.constant';
import { CreditAppraisalService } from 'app/credit/services';
import { saveAs } from 'file-saver';

import { DocumentpUloadService } from 'app/shared/services/document-upload.service';
@Component({
    templateUrl: 'loan-restructuring-approval.component.html'
})

export class LoanRestructuringApprovalComponent implements OnInit {
    twoFactorAuthStaffCode: string = null;
    twoFactorAuthPassCode: string = null;
    passCode: any;
    username: string;
    reload: number = 0;
    displayTwoFactorAuth: boolean = false;
    twoFactorAuthEnabled: boolean = false;
    displayRestructuringApprovalModal: boolean = false;
    loanOperationApprovalData: any[] = [];
    loanSelectedData: any = {};
    loanSelection: any;
    approvalStatusData: any[];
    approvalWorkflowData: any[];
    activeIndex = 0;
    loanSystemTypeId: any;
    loanId: any;
    isLms: boolean = true;
    isCRMSstaff: any;
    jobSourceId: number;
    displayConfirmDialog: boolean;
    width: string;
    message: string;
    title: string;
    originalForm3800bSrc: any;
    lmsLoanReferenceNumber: any;
    displayTestReport: boolean;
    displayReport: boolean;
    reportSrc: SafeResourceUrl;
    activeTabindex: number;
    RegulatoryInterestRateChange: boolean = false;
    SubAllocationOverdraft: boolean = false;
    PrepaymentChange: boolean = false;
    PrincipalFrequencyChange: boolean = false;
    InterestFrequencyChange: boolean = false;
    InterestandPrincipalFrequencyChange: boolean = false;
    PaymentDateChange: boolean = false;
    TenorChange: boolean = false;
    CASAAccountChange: boolean = false;
    Overdrafttopup: boolean = false;
    FeechargeChange: boolean = false;
    TerminateandRebook: boolean = false;
    CompleteWriteOff: boolean = false;
    CancelUndisbursedLoan: boolean = false;
    Restucture: boolean = false;
    LoanRecapitalization: boolean = false;
    OverdraftTenorExtension: boolean = false;
    OverdraftSubAllocation: boolean = false;
    OverdraftRenewal: boolean = false;
    OverdraftInterestRateReview: boolean = false;
    ContingentLiabilityTermination: boolean = false;
    ContingentLiabilityTenorExtension: boolean = false;
    ContingentLiabilityAmountReduction: boolean = false;
    ContingentLiabilityAmountAddition: boolean = false;
    ContingentLiabilityRenewal: boolean = false;
    ContingentLiabilityRebook: boolean = false;
    CancelContingentLiability: boolean = false;

    OPERATION_ID: number = 46;
    documentations: any[] = [];
    displayDocumentation: boolean = false;
    selectedloanReviewApplicationId: number;
    isOverDraft: boolean = false;
    contingentFacility: boolean =false;
    Others: boolean = false;
    type: any ;
    reportSource: SafeResourceUrl;

    supportingDocuments: any[] = [];
    attachmentDocuments: any[] = [];

    uploadFileTitle: string = null;
    files: FileList;
    file: File;
    fileDocument: any;
    pdfFile: any;
    pdfFileName: string;
    displayPdf: boolean = false;
    myDocExtention: string;
    pdfData: any;
    fileUrl: string;
    scatterdPayments: any[] = [];
    loanOperationApprovalFees: any[];
    convenatDetails: any[];

    collateralDetails: any[]; // LoanCovenantModel[] = [];;
    guarantorDetails: any[]; // GuarantorAppModel[] = [];
    chargeFeeDetails: any[];
    loanScheduleDetails: any[];
    displayCustomerODDetails: boolean = false;

    constructor(private loadingService: LoadingService, private fb: FormBuilder, private loanApplService: LoanApplicationService,
        private loanOperationService: LoanOperationService, private loanService: LoanService, private genSetupService: GeneralSetupService,
        private approvalService: ApprovalService, private router: Router,  private documentpUloadService: DocumentpUloadService, 
        private authorizationService: AuthorizationService,    private camService: CreditAppraisalService,
        private reportServ: ReportService, private sanitizer: DomSanitizer, ) {
    }

    ngOnInit() {
        this.jobSourceId  = JobSource.LMSOperationAndApproval;
        this.loadingService.show();
        this.getAllLoansOperationForApproval();
        this.getAllApprovalStatus();
        this.displayReport = false;
    }
    closeDocumentation() {
        this.displayDocumentation = false;
        this.documentations = [];
    }
      previewDocumentation(print=false) {
        this.loadingService.show();
        this.camService.getDocumentation(this.OPERATION_ID, this.selectedloanReviewApplicationId).subscribe((response: any) => {
            this.documentations = response.result;
            ////console.log('getDocumentation -> ', response);
            this.loadingService.hide();
             if (print == false) this.displayDocumentation = true;
        }, (err) => {
            this.loadingService.hide(1000);
        });
    }
    getStaffActivity(activity) {
        this.camService.getStaffActivity(activity).subscribe((response: any) => {
            this.isCRMSstaff = response.result;
        });
    }
    hideAllControl() {
        this.RegulatoryInterestRateChange = false;
        this.SubAllocationOverdraft = false;
        this.PrepaymentChange = false;
        this.PrincipalFrequencyChange = false;
        this.InterestFrequencyChange = false;
        this.InterestandPrincipalFrequencyChange = false;
        this.PaymentDateChange = false;
        this.TenorChange = false;
        this.CASAAccountChange = false;
        this.Overdrafttopup = false;
        this.FeechargeChange = false;
        this.TerminateandRebook = false;
        this.CompleteWriteOff = false;
        this.CancelUndisbursedLoan = false;
        this.Restucture = false;
        this.LoanRecapitalization = false;
        this.isOverDraft = false;


        this.ContingentLiabilityTermination  = false;
        this.ContingentLiabilityTenorExtension = false;
        this.ContingentLiabilityAmountReduction = false;
        this.ContingentLiabilityAmountAddition = false;
        this.ContingentLiabilityRenewal = false;
        this.ContingentLiabilityRebook = false;
        this.CancelContingentLiability = false;
    }

    getAllLoansOperationForApproval() {
        this.loanOperationService.getAllLoanOperationAwaitingApproval().subscribe((response: any) => {
            this.loanOperationApprovalData = response.result;
            this.loadingService.hide();
        });
    }



    GetLaonConvenant(loanId) {
        this.loanOperationService.getLoanConvenant(loanId)
          .subscribe((results: any ) => {
            this.convenatDetails = results.result;
          });
          this.check(this.loanSelectedData.productTypeId);
      }
      GetLoanCollateral(loanId) {
        this.loanOperationService.getLoanCollateral(loanId)
          .subscribe((results: any ) => {
            this.collateralDetails = results.result;
          });
          this.check(this.loanSelectedData.productTypeId);
      }
      GetLaonChargeFee(loanId) {
        this.loanOperationService.getLoanChargeFee(loanId)
          .subscribe((results: any ) => {
            this.chargeFeeDetails = results.result;
          });
          this.check(this.loanSelectedData.productTypeId);
      }
 GetLaonConvenantOD(loanId,loanType) {
    this.loanOperationService.getLoanConvenantOD(loanId,loanType)
      .subscribe((results: any ) => {
        this.convenatDetails = results.result;
      });
      this.check(this.loanSelectedData.productTypeId);
  }
  GetLoanCollateralOD(loanId,loanType) {
    this.loanOperationService.getLoanCollateralOD(loanId,loanType)
      .subscribe((results: any ) => {
        this.collateralDetails = results.result;
      });
      this.check(this.loanSelectedData.productTypeId);
  }
  GetLaonChargeFeeOD(loanId,loanType) {
    this.loanOperationService.getLoanChargeFeeOD(loanId,loanType)
      .subscribe((results: any ) => {
        this.chargeFeeDetails = results.result;
      });
      this.check(this.loanSelectedData.productTypeId);
  }
  GetLaonScheduleByLoanId(loanId) {
    this.loanOperationService.getLoanScheduleByLoanId(loanId)
      .subscribe((results: any ) => {
        this.loanScheduleDetails = results.result;
      });
      this.check(this.loanSelectedData.productTypeId);
  }
  check(productTypeId){
    if(productTypeId == 6 || productTypeId == 9){
      this.displayCustomerODDetails = true;
     
    }
    else
    {
      this.displayCustomerODDetails = false;
     
    }
  }

    getAllApprovalStatus(): void {
        this.genSetupService.getApprovalStatus().subscribe((response: any) => {
            let tempData = response.result;
            this.approvalStatusData = tempData.slice(2, 4);
        });
    }
    hasFees: boolean = false;
    terminateRebook: boolean = false;
    loanReviewOperationsId: number;
    showAttachedDocument: boolean = false;
    ammendedAmount: number=0;


    displayJobrequest = false;
 
    lmsOperationId: number;
    CallRequestClose() { this.displayJobrequest = false; }
    loanApplDetailId = 0;
initiateRequest(){
    this.displayJobrequest=true;
}


    viewLoanDetails(row, evt) {
        evt.preventDefault();
        this.hideAllControl();
        this.loanSelectedData = {};
        this.loanSelectedData = row;
        this.loanSelectedData.approvalStatusId = "";
        this.loanReviewOperationsId = this.loanSelectedData.loanReviewOperationsId;

        // this.loanOperationService.getAllLoanOperationAwaitingApproval().subscribe((response: any) => {
        //     this.loanOperationApprovalData = response.result;

        //     this.loadingService.hide();
        // });


        let dataObj = this.loanSelectedData;

        this.approvalService.getApprovalTrailByOperation(dataObj.operationId, dataObj.loanId).subscribe((res: any) => {
            this.approvalWorkflowData = res.result;
        });



        this.lmsLoanReferenceNumber = this.loanSelectedData.lmsLoanReferenceNumber;


        //this.loadOriginalForm3800BTemplate(this.lmsLoanReferenceNumber)
       // this.form3800b(this.lmsLoanReferenceNumber)
       // this.loadOriginalForm3800BTemplate(this.lmsLoanReferenceNumber)

        this.selectedloanReviewApplicationId = this.loanSelectedData.loanReviewApplicationId;
this.loanApplDetailId = this.loanSelectedData.loanReviewApplicationId;


let facilityType = this.loanSelectedData.loanSystemTypeId;
this.loanSystemTypeId = facilityType;
this.loanId = dataObj.loanId;
this.isLms = true;
this.loanOperationApprovalFees = this.loanSelectedData.fees;
this.showAttachedDocument=false;
//console.log(this.loanSelectedData.fees.length);
if (this.loanSelectedData.fees.length > 0){
    this.hasFees=true;
}else{
    this.hasFees = false;
}


//let loantype = 0;
if(facilityType==LoanSystemTypeEnum.ContingentFacility)
{    
    this.contingentFacility=true;
    this.GetLaonConvenantOD(this.loanId,facilityType);
    this.GetLoanCollateralOD(this.loanId,facilityType);
    this.GetLaonChargeFeeOD(this.loanId,facilityType);
this.GetLaonScheduleByLoanId(this.loanId);
}
else{
    this.contingentFacility = false;
    if(facilityType==LoanSystemTypeEnum.TermDisbursedFacility)
{
    this.GetLaonConvenant(this.loanId);
    this.GetLoanCollateral(this.loanId);
    this.GetLaonChargeFee(this.loanId);
    this.GetLaonScheduleByLoanId(this.loanId);
}
else if(facilityType==LoanSystemTypeEnum.OverdraftFacility){

}
}

        //console.log('this.loanSelectedData.operationTypeId', this.loanSelectedData.operationTypeId);
        let event = this.loanSelectedData.operationTypeId;
                this.lmsOperationId = this.loanSelectedData.operationTypeId;

        let type = this.loanSelectedData.scheduleDayInterestTypeId;
if (type = 0)
{
this.type = "First Day Interest";
}
else
{
    this.type = "Second Day Interest";
}
if (event == LMSOperationEnum.ContingentLiabilityRebook || event == LMSOperationEnum.CancelContingentLiability){
    this.terminateRebook = true;
}
else{
    this.terminateRebook = false;
}
        if (event == LMSOperationEnum.InterestRateChange) {
            this.RegulatoryInterestRateChange = true;
            this.isOverDraft = false;

            ////console.log('this.event 19', event);
        }        
        else if (event == LMSOperationEnum.Prepayment) {
            this.PrepaymentChange = true;
            this.isOverDraft = false;

            ////console.log('this.event 21', event);
        }
        // else if (event == LMSOperationEnum.PrincipalFrequencyChange)
        // {
        //     this.PrincipalFrequencyChange = true;
        //     ////console.log('this.event 22', event);
        // }
        else if (event == LMSOperationEnum.InterestFrequencyChange) {
            this.InterestFrequencyChange = true;
            this.isOverDraft = false;

            ////console.log('this.event 23', event);
        }
        else if (event == LMSOperationEnum.InterestAndPrincipalFrequencyChange) {
            this.InterestandPrincipalFrequencyChange = true;
            this.isOverDraft = false;

            ////console.log('this.event 24', event);
        }
        else if (event == LMSOperationEnum.PaymentDateChange) {
            this.PaymentDateChange = true;
            this.isOverDraft = false;

            ////console.log('this.event 25', event);
        }
        else if (event == LMSOperationEnum.TenorExtension) {
            this.TenorChange = true;
            this.isOverDraft = false;

            ////console.log('this.event 26', event);
        }
        else if (event == LMSOperationEnum.ChangeRepaymentAccount) {
            this.CASAAccountChange = true;
            this.isOverDraft = false;

            ////console.log('this.event 27', event);
        }
        else if (event == LMSOperationEnum.OverdraftTopup) {
            this.Overdrafttopup = true;
            this.isOverDraft = true;
            ////console.log('this.event 28', event);
        }
        else if (event == LMSOperationEnum.FeeChargeChange) {
            this.FeechargeChange = true;
            this.isOverDraft = false;

            ////console.log('this.event 29', event);
        }
        else if (event == LMSOperationEnum.Restructure) {
            this.Restucture = true;
            this.isOverDraft = false;

            ////console.log('this.event 51', event);
        }
         else if (event == LMSOperationEnum.LoanRecapitilization)
        {
            this.LoanRecapitalization = true;
            this.isOverDraft = false;

            ////console.log('this.event 59', event);
        }
        else if (event == LMSOperationEnum.OverdraftTenorExtension)
        {
            this.OverdraftTenorExtension = true;
            this.isOverDraft = true;

        }       
        else if (event == LMSOperationEnum.OverdraftSubAllocation)
        {
            this.OverdraftSubAllocation = true;
            this.isOverDraft = true;

        }        
        else if (event == LMSOperationEnum.OverdraftRenewal)
        {
            this.OverdraftRenewal = true;
            this.isOverDraft = true;

        }
        else if (event == LMSOperationEnum.OverdraftInterestRateReview)
        {
            this.OverdraftInterestRateReview = true;
            this.isOverDraft = true;

        }
        else if (event == LMSOperationEnum.LoanWorkOut)
        {
            this.getLoanReviewOperationIrregularSchedule(row.loanReviewOperationsId); // TODO
            this.Others = true;
            this.isOverDraft = false;
        }
        else if (event == LMSOperationEnum.ContingentLiabilityRenewal)
        {
            this.ContingentLiabilityRenewal = true;
            this.isOverDraft = false;
            this.showAttachedDocument=true;
            this.getAllUploadedOperationDocument();

        } 
        else if (event == LMSOperationEnum.ContingentLiabilityRebook)
        {
            this.ContingentLiabilityRebook = true;
            this.isOverDraft = false;
            this.showAttachedDocument=true;
            this.getAllUploadedOperationDocument();


        }
         else if (event == LMSOperationEnum.CancelContingentLiability)
        {
            this.CancelContingentLiability = true;
            this.isOverDraft = false;

        }
        else if (event == LMSOperationEnum.ContingentLiabilityTermination)
        {

            this.ContingentLiabilityTermination = true;
            this.isOverDraft = false;
            this.showAttachedDocument=true;
            this.getAllUploadedOperationDocument();


        }
        else if (event == LMSOperationEnum.ContingentLiabilityTenorExtension)
        {
            this.ContingentLiabilityTenorExtension = true;
            this.isOverDraft = false;

        }
        else if (event == LMSOperationEnum.ContingentLiabilityAmountReduction)
        {
            this.ammendedAmount  =0;
            this.ammendedAmount = this.loanSelectedData.principalAmount - this.loanSelectedData.prepayment;

            this.ContingentLiabilityAmountReduction = true;
            this.isOverDraft = false;

        }
        else if (event == LMSOperationEnum.ContingentLiabilityAmountAddition)
        {
            this.ammendedAmount  =0;

            this.ammendedAmount = this.loanSelectedData.principalAmount + this.loanSelectedData.prepayment;

            this.ContingentLiabilityAmountAddition = true;
            this.isOverDraft = false;

        }        
        else
        //(event == LMSOperationEnum.LoanRecapitilization)
        {
            this.Others = true;
            this.isOverDraft = false;

        }
        this.getAllUploadedDocument();
        this.getStaffActivity('crms-user')

        this.displayRestructuringApprovalModal = true;


    }

    promptToGoForApproval(formObj) {
        if (formObj.approvalStatusId == ApprovalStatusEnum.Referred){
            this.goForApproval(formObj);
        }
        else{
            this.authorizationService.enable2FAForLastApproval(formObj.operationTypeId
                , null, formObj.productId, 0).subscribe((res: any) => {
                    if (res.result == true) {
                        this.displayTwoFactorAuth = true;
                    } else {
                        this.goForApproval(formObj);
                    }
                })
        }        
    }

    goForApproval(formObj) {
        let loading = this.loadingService;
        let srv = this.loanService;
        this.displayRestructuringApprovalModal = false;
        // let selectedLoanReviewOperationId = this.loanSelectedData.loanReviewOperationsId;
        let bodyObj = {
            operationId: this.loanSelectedData.operationTypeId,
            targetId: this.loanSelectedData.loanReviewOperationsId,
            approvalLevelId: this.loanSelectedData.currentApprovalLevelId,
            approvalStatusId: formObj.approvalStatusId,
            comment: formObj.comment,
            userName: this.twoFactorAuthStaffCode,
            passCode: this.twoFactorAuthPassCode,
        };
        this.displayTwoFactorAuth = false;
        const __this = this;
        swal({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No, cancel!',
            confirmButtonClass: 'btn btn-success btn-move',
            cancelButtonClass: 'btn btn-danger',
            buttonsStyling: true,
        }).then(function () {
            __this.loadingService.show();
            __this.loanOperationService.sendLoanOperationForApproval(bodyObj).subscribe((response: any) => {
                __this.loadingService.hide();
                __this.twoFactorAuthPassCode = null;
                __this.twoFactorAuthStaffCode = null;
                if (response.success === true) {
                    __this.twoFactorAuthPassCode = null;
                    __this.twoFactorAuthStaffCode = null;
                    __this.getAllLoansOperationForApproval();
                    swal(`${GlobalConfig.APPLICATION_NAME}`, response.message, 'success');
                    __this.displayRestructuringApprovalModal = false;
                } else {
                    swal(`${GlobalConfig.APPLICATION_NAME}`, response.message, 'error');
                    __this.displayRestructuringApprovalModal = true;
                }

            }, (err) => {
                __this.loadingService.hide();
                swal(`${GlobalConfig.APPLICATION_NAME}`, JSON.stringify(err), 'error');
            });
        }, function (dismiss) {
            if (dismiss === 'cancel') {
                swal(`${GlobalConfig.APPLICATION_NAME}`, 'Operation cancelled', 'error');
            }
        });
    }

    cancelApproval() {
        swal(`${GlobalConfig.APPLICATION_NAME}`, 'Approval cancelled', 'error');
        this.displayConfirmDialog = false;
        this.displayRestructuringApprovalModal = false;
    }

    hideModal() {
        this.handleChange(0);
        this.activeIndex = 0;
        this.displayRestructuringApprovalModal = false;
    }

    handleChange(e) {
        this.activeIndex = e.index;
    }

    next() {
        this.activeIndex = (this.activeIndex === 3) ? 0 : this.activeIndex + 1;
    }

    prev() {
        this.activeIndex = (this.activeIndex === 0) ? 2 : this.activeIndex - 1;
    }

    loadOriginalForm3800BTemplate(applicationReferenceNumber: string) {
        this.loadingService.show();
        this.loanApplService.getForm3800TemplateLMS(applicationReferenceNumber)
            .subscribe((response: any) => {
                let tempSrc = response.result;
                if (tempSrc != null) {
                    this.originalForm3800bSrc = tempSrc;
                }
                else this.originalForm3800bSrc = {};
                this.loadingService.hide();
            }, (err) => {
                this.loadingService.hide();
                swal(`${GlobalConfig.APPLICATION_NAME}`, err, 'error');
                ////console.log('error', err);
            });
    }
  
    popoverSeeMore() {
        if (this.lmsLoanReferenceNumber != null) {
            ////console.log('more..', startDate, endDate);
            this.displayTestReport = false;
            this.displayReport = false;
            let path = '';
            const data = {
                applicationRefNumber: this.lmsLoanReferenceNumber,

            }
            ////console.log(data);

            this.reportServ.getGeneratedOfferLetterLMS(data.applicationRefNumber).subscribe((response: any) => {
                path = response.result;
                ////console.log(path);
                this.reportSrc = this.sanitizer.bypassSecurityTrustResourceUrl(path);
                this.displayTestReport = true;
                ////console.log(path);
            });
            this.displayReport = true;
            this.activeTabindex = 0;
            this.loadingService.show();
            this.loadingService.hide(1000);
            return;
        }
    }
    form3800b(applicationReferenceNumber): void {
        if (applicationReferenceNumber != null) {
            let path = '';
            const data = {
                applicationRefNumber:applicationReferenceNumber,

            }
            ////console.log(data);

            this.reportServ.printLMSForm3800B(data.applicationRefNumber).subscribe((response: any) => {
                path = response.result;
                ////console.log(path);
                this.reportSource = this.sanitizer.bypassSecurityTrustResourceUrl(path);
                this.displayTestReport = true;
                ////console.log(path);
            });
            //this.displayReport = true;
            return;
        }
       
    }


    getAllUploadedDocument() {
        this.loadingService.show();
       

        let body = {
          loanApplicationId: this.loanSelectedData.loanReviewApplicationId,
          loanApplicationNumber: this.lmsLoanReferenceNumber,
          loanReferenceNumber: this.loanSelectedData.loanReferenceNumber,
          databaseTable: 8,

        }
        
      
        this.documentpUloadService.getAllUploadedDocument(body).subscribe((response: any) => {
            this.supportingDocuments = response.result;
            this.loadingService.hide();
        }, (error) => {
            this.loadingService.hide(1000);
        });
      }
    
      getAllUploadedOperationDocument() {
        this.loadingService.show();
       

        let body = {
          loanApplicationId: this.loanSelectedData.loanReviewApplicationId,
          loanApplicationNumber: this.lmsLoanReferenceNumber,
          loanReferenceNumber: this.loanSelectedData.loanReferenceNumber,
          databaseTable: 8,
          operationReviewId: this.loanReviewOperationsId,
        }
        
      
        this.documentpUloadService.getAllUploadedOperationsDocument(body).subscribe((response: any) => {
            this.attachmentDocuments = response.result;
            this.loadingService.hide();
        }, (error) => {
            this.loadingService.hide(1000);
        });
      }


      binaryFile: string;
      selectedDocument: string;
      displayDocument: boolean = false;
      myPdfFile: any;
    
      viewDocument(row) {
          this.loadingService.show();
          this.documentpUloadService.getUploadedDocument(row).subscribe((response: any) => {
              this.binaryFile = response.result.fileData;
              this.selectedDocument = response.result.documentTitle;
              this.displayDocument = true;
              this.loadingService.hide();
          }, (error) => {
              this.loadingService.hide(1000);
          });
      }
      viewPdfDocument(id: number) {
        let doc = this.supportingDocuments.find(x => x.documentId == id);
        if (doc != null) {
            this.displayPdf = true;
            this.fileUrl = 'https://cdn.rawgit.com/DenisVuyka/pdf-test-01/4b729e21/sample.pdf';
        };
    }
    
    viewExcelDocument(id: number) {
        let doc = this.supportingDocuments.find(x => x.documentId == id);
        if (doc != null) {
            this.pdfFile = doc.fileData;
            this.pdfFileName = doc.documentTitle;
            var byteString = atob(this.pdfFile);
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            var bb = new Blob([ab]);
            var file = new File([bb], this.pdfFileName + '.xlsx', { type: 'application/vnd.ms-excel' });
            // saveAs(file)
        }
    }
    
    
    DownloadDocument(id: number) {
        this.fileDocument = null;
        this.camService.getSupportingDocumentByDocumentId(id).subscribe((response: any) => {
            this.fileDocument = response.result;
            // let doc = this.loanDocumentUploadList.find(x => x.documentId == id);
            if (this.fileDocument != null) {
                this.binaryFile = this.fileDocument.fileData;
                this.selectedDocument = this.fileDocument.documentTitle;
                let myDocExtention = this.fileDocument.fileExtension;
                var byteString = atob(this.binaryFile);
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                var bb = new Blob([ab]);
    
                if (myDocExtention == 'jpg' || myDocExtention == 'jpeg') {
                    try {
                        var file = new File([bb], this.selectedDocument + '.jpg', { type: 'image/jpg' });
                        saveAs(file);
                    } catch (err) {
                        var saveFileAsBlob = new Blob([bb], { type: 'image/jpg' });
                        window.navigator.msSaveBlob(saveFileAsBlob, this.selectedDocument + '.jpg');
                    }
                }
                if (myDocExtention == 'png' || myDocExtention == 'png') {
                    try {
                        var file = new File([bb], this.selectedDocument + '.png', { type: 'image/png' });
                        saveAs(file);
                    } catch (err) {
                        var saveFileAsBlob = new Blob([bb], { type: 'image/png' });
                        window.navigator.msSaveBlob(saveFileAsBlob, this.selectedDocument + '.png');
                    }
                }
                if (myDocExtention == 'pdf' || myDocExtention == '.pdf') {
                    try {
                        var file = new File([bb], this.selectedDocument + '.pdf', { type: 'application/pdf' });
                        saveAs(file);
                    } catch (err) {
                        var saveFileAsBlob = new Blob([bb], { type: 'application/pdf' });
                        window.navigator.msSaveBlob(saveFileAsBlob, this.selectedDocument + '.pdf');
                    }
                }
                if (myDocExtention == 'xls' || myDocExtention == 'xlsx') {
                    try {
                        var file = new File([bb], this.selectedDocument + '.xlsx', { type: 'application/vnd.ms-excel' });
                        saveAs(file);
                    } catch (err) {
                        var saveFileAsBlob = new Blob([bb], { type: 'application/vnd.ms-excel' });
                        window.navigator.msSaveBlob(saveFileAsBlob, this.selectedDocument + '.xlsx');
                    }
                }
                if (myDocExtention == 'doc' || myDocExtention == 'docx') {
    
                    try {
                        var file = new File([bb], this.selectedDocument + '.doc', { type: 'application/msword' });
                        saveAs(file);
                    } catch (err) {
                        var saveFileAsBlob = new Blob([bb], { type: 'application/msword' });
                        window.navigator.msSaveBlob(saveFileAsBlob, this.selectedDocument + '.doc');
                    }
                }
            }
        });
    }

    getLoanReviewOperationIrregularSchedule(id) {
        this.loanOperationService.getLoanReviewOperationIrregularSchedule(id).subscribe((response: any) => {
            this.scatterdPayments = response.result;
        });
    }
    
}
